export const FREE_DELIVERY_THRESHOLD = 1500;
export const FLAT_DELIVERY = 79;
export const DEMO_COUPON = "AYUSHI10";

export const PRODUCTS = [
  {
    id: "kaachenna-hair-oil",
    slug: "kaachenna-hair-oil",
    name: "Kaachenna Hair Oil",
    category: "Hair Care",
    size: "200 ml",
    price: 450,
    commonName: "Hair oil",
    cardLine: "Traditional Ayurvedic hair oil, made in small batches.",
    images: ["/assets/p-kaachenna-hair-oil.jpg"],
    short:
      "The oldest item in the range, and the one Dr. Shibina is proudest of. It is prepared the slow way, with herbs cooked into the oil, and it is heavier than a modern serum — that is the point. Warm it slightly, work it into the scalp, and leave it in.",
    keyIngredients: [
      { name: "Amla", line: "The base of most classical hair oils." },
      { name: "Curry leaf", line: "A Kerala kitchen staple, cooked into the oil." },
      { name: "Fenugreek", line: "Added for softness and slip." },
    ],
    fullIngredients:
      "Amla, curry leaf, fenugreek and other herbs cooked into a base oil. Complete list printed on the pack.",
    howToUse: [
      "Warm a small quantity between the palms.",
      "Part the hair and apply to the scalp.",
      "Massage in slow circles for a few minutes.",
      "Leave for at least an hour, or overnight, then wash out.",
    ],
    bestseller: true,
  },
  {
    id: "dandruff-care-shampoo",
    slug: "dandruff-care-shampoo",
    name: "Dandruff Care Shampoo",
    category: "Hair Care",
    size: "200 ml",
    price: 550,
    commonName: "Shampoo",
    badge: "SLS & paraben free",
    cardLine: "A gentle wash for a scalp that needs looking after.",
    images: ["/assets/p-dandruff-care-shampoo.jpg", "/assets/img-a1.jpeg"],
    short:
      "Free of SLS and parabens, so it lathers less than a supermarket shampoo — that is expected, not a fault. It cleanses the scalp and hair without stripping, and it is designed for regular use, not occasional treatment. Pairs well with the Aloe Vera Hair Conditioner.",
    keyIngredients: [
      { name: "Aloe vera", line: "Keeps the wash from feeling harsh." },
      { name: "Neem", line: "A classic in scalp care." },
      { name: "Mild cleansers", line: "No SLS, no parabens." },
    ],
    fullIngredients: "Complete list printed on the pack. Free of SLS and parabens.",
    howToUse: [
      "Wet the hair thoroughly.",
      "Work a small amount into the scalp.",
      "Leave for two to three minutes.",
      "Rinse well and follow with conditioner.",
    ],
  },
  {
    id: "aloe-vera-hair-conditioner",
    slug: "aloe-vera-hair-conditioner",
    name: "Aloe Vera Hair Conditioner",
    category: "Hair Care",
    size: "200 ml",
    price: 450,
    commonName: "Hair conditioner",
    cardLine: "Softens and detangles, without the coating.",
    images: ["/assets/p-aloe-vera-hair-conditioner.jpg", "/assets/lifestyle-1.png"],
    short:
      "Aloe vera based, light, and it rinses cleanly. Hair feels softer and combs easier, without the coated feeling some conditioners leave. Made to follow the Dandruff Care Shampoo, but it works after any wash.",
    keyIngredients: [
      { name: "Aloe vera", line: "The base of the whole formula." },
      { name: "Light emollients", line: "Softness without the coating." },
    ],
    fullIngredients: "Complete list printed on the pack.",
    howToUse: [
      "After shampooing, squeeze out the excess water.",
      "Apply along the lengths, avoiding the scalp.",
      "Leave for two minutes.",
      "Rinse thoroughly.",
    ],
  },
  {
    id: "aloevera-gel-dandruff-care",
    slug: "aloevera-gel-dandruff-care",
    name: "Aloevera Gel for Dandruff Care",
    category: "Hair Care",
    size: "100 gm",
    price: 500,
    commonName: "Scalp gel",
    cardLine: "A leave-in gel for the scalp, between washes.",
    images: ["/assets/p-aloevera-gel-dandruff-care.jpg", "/assets/img-a4.jpeg"],
    short:
      "An aloe vera gel made for the scalp, not the skin. It absorbs without leaving the hair greasy, and it is cooling on application. For the days between washes when the scalp feels dry or tight.",
    keyIngredients: [
      { name: "Aloe vera", line: "Cooling, light, quick to absorb." },
    ],
    fullIngredients: "Complete list printed on the pack.",
    howToUse: [
      "Part the hair in sections.",
      "Apply a small quantity directly to the scalp.",
      "Massage lightly.",
      "Leave in. No need to rinse.",
    ],
  },
  {
    id: "dandruff-oil",
    slug: "dandruff-oil",
    name: "Dandruff Oil",
    category: "Hair Care",
    size: "100 ml",
    price: 400,
    commonName: "Scalp oil",
    cardLine: "A lighter scalp oil, for use before washing.",
    images: [],
    labelCard: true,
    short:
      "Lighter than Kaachenna, and made for the scalp rather than the lengths. Applied an hour or so before washing, it loosens dryness so the shampoo can do its work. Used once or twice a week, alongside the Dandruff Care Shampoo.",
    keyIngredients: [
      { name: "Light herbal oil base", line: "Made for the scalp, not the lengths." },
    ],
    fullIngredients: "Complete list printed on the pack.",
    howToUse: [
      "Apply to the scalp with the fingertips.",
      "Massage gently.",
      "Leave for at least an hour.",
      "Wash out with Dandruff Care Shampoo.",
    ],
    photoNote: "Photograph coming soon",
  },
  {
    id: "neem-anti-lice-shampoo",
    slug: "neem-anti-lice-shampoo",
    name: "Neem Anti Lice Shampoo",
    category: "Hair Care",
    size: "200 ml",
    price: 415,
    commonName: "Shampoo",
    badge: "SLS & paraben free",
    cardLine: "A neem-based wash, made from natural ingredients.",
    images: ["/assets/p-neem-anti-lice-shampoo.jpg", "/assets/lifestyle-2.png"],
    short:
      "A neem-based wash, free of SLS and parabens, made from natural ingredients. It is a regular wash, not a one-off — use it as you would any shampoo, and follow with the Aloe Vera Hair Conditioner.",
    keyIngredients: [
      { name: "Neem", line: "The heart of the formula." },
      { name: "Mild cleansers", line: "No SLS, no parabens." },
    ],
    fullIngredients: "Complete list printed on the pack. Free of SLS and parabens.",
    howToUse: [
      "Wet the hair thoroughly.",
      "Work a small amount into the scalp and lengths.",
      "Leave for two minutes.",
      "Rinse well and follow with conditioner.",
    ],
  },
  {
    id: "aloevera-facewash-charcoal",
    slug: "aloevera-facewash-with-charcoal",
    name: "Aloevera Facewash with Charcoal",
    category: "Skin Care",
    size: "100 ml",
    price: 315,
    commonName: "Face wash",
    cardLine: "Aloe vera and activated charcoal. The everyday wash.",
    images: ["/assets/p-aloevera-facewash-charcoal.jpg"],
    short:
      "The most affordable product in the range, and where most people start. Aloe vera and activated charcoal — the charcoal lifts the day off, the aloe keeps it from feeling stripped. Suits most skin, including oily skin in Kerala humidity. Morning and evening.",
    keyIngredients: [
      { name: "Aloe vera", line: "Stops the wash feeling stripped." },
      { name: "Activated charcoal", line: "Lifts the day off the skin." },
    ],
    fullIngredients: "Aloe vera, activated charcoal. Complete list printed on the pack.",
    howToUse: [
      "Wet the face with lukewarm water.",
      "Work a small amount into a lather.",
      "Massage in circles for thirty seconds, avoiding the eyes.",
      "Rinse and pat dry.",
    ],
    bestseller: true,
    entry: true,
  },
  {
    id: "lip-balm",
    slug: "lip-balm",
    name: "Lip Balm",
    category: "Skin Care",
    size: "25 gm",
    price: 400,
    commonName: "Lip balm",
    cardLine: "A rich balm in a jar, not a stick.",
    images: ["/assets/p-lip-balm.jpg", "/assets/img-a2.jpeg", "/assets/img-a3.jpeg"],
    short:
      "Thicker and richer than a stick balm, and it lasts — twenty-five grams is a lot of lip balm. It softens dry lips and holds through the day. Also the nicest-looking thing we make, and popular as a gift.",
    keyIngredients: [
      { name: "Beeswax", line: "What makes it hold through the day." },
      { name: "Ghee", line: "Traditional, and very softening." },
    ],
    fullIngredients: "Complete list printed on the pack.",
    howToUse: [
      "Take a small amount on a clean fingertip.",
      "Smooth over the lips.",
      "Reapply as needed, and at night before sleeping.",
    ],
    bestseller: true,
  },
  {
    id: "nalpamaradi-face-cream",
    slug: "nalpamaradi-face-cream",
    name: "Nalpamaradi Face Cream",
    category: "Skin Care",
    size: "100 gm",
    price: 600,
    commonName: "Face cream",
    cardLine: "A classical Kerala preparation, made into a daily face cream.",
    images: ["/assets/p-nalpamaradi-face-cream.jpg"],
    short:
      "Built around nalpamaram — the four ficus barks of classical Kerala Ayurveda — and turmeric. Most versions of this preparation are oils; ours is a cream, made for morning use. Rich, so a small amount is enough, and it sinks in. Made in the smallest batches of anything we sell.",
    keyIngredients: [
      { name: "Nalpamaram", line: "The four ficus barks of the classical formula." },
      { name: "Turmeric", line: "The other half of the tradition." },
      { name: "Cream base", line: "So it works as a daily moisturiser." },
    ],
    fullIngredients: "The four nalpamaram barks and turmeric in a cream base. Complete list printed on the pack.",
    howToUse: [
      "Wash the face and pat dry.",
      "Take a small amount on the fingertips.",
      "Smooth over the face and neck.",
      "Use morning and night, or at night alone.",
    ],
    flagship: true,
  },
  {
    id: "foot-balm",
    slug: "foot-balm",
    name: "Foot Balm",
    category: "Body Care",
    size: "100 gm",
    price: 450,
    commonName: "Skin balm",
    cardLine: "A thick balm for feet that have had a long day.",
    images: ["/assets/p-foot-balm.jpg", "/assets/img-a5.jpeg"],
    short:
      "Thick, rich and slightly cooling. Made for hard, dry heels and soles, and best applied at night. A little goes a long way — a hundred-gram jar lasts months. Softens, cools and comforts; that is the whole promise.",
    keyIngredients: [
      { name: "Beeswax", line: "Gives the balm its body." },
      { name: "Coconut oil", line: "Softening, and close to home." },
    ],
    fullIngredients: "Complete list printed on the pack.",
    howToUse: [
      "Wash and dry the feet.",
      "Take a small amount and massage into heels and soles.",
      "Put on a pair of cotton socks.",
      "Leave overnight.",
    ],
    bestseller: true,
  },
].map((p, i) => ({ ...p, num: String(i + 1).padStart(2, "0") }));

export const SETS = [
  {
    id: "set-wash",
    slug: "the-wash-set",
    name: "The Wash Set",
    kind: "set",
    price: 900,
    contents: ["Dandruff Care Shampoo", "Aloe Vera Hair Conditioner"],
    items: ["dandruff-care-shampoo", "aloe-vera-hair-conditioner"],
    note: "The obvious pair, made for each other.",
    image: "/assets/p-dandruff-care-shampoo.jpg",
  },
  {
    id: "set-scalp",
    slug: "the-scalp-set",
    name: "The Scalp Set",
    kind: "set",
    price: 1300,
    contents: ["Dandruff Oil", "Dandruff Care Shampoo", "Aloevera Gel"],
    items: ["dandruff-oil", "dandruff-care-shampoo", "aloevera-gel-dandruff-care"],
    note: "The full routine — oil before the wash, gel between washes. The most complete thing we sell.",
    image: "/assets/p-aloevera-gel-dandruff-care.jpg",
  },
  {
    id: "set-traditional",
    slug: "the-traditional-set",
    name: "The Traditional Set",
    kind: "set",
    price: 810,
    contents: ["Kaachenna Hair Oil", "Aloe Vera Hair Conditioner"],
    items: ["kaachenna-hair-oil", "aloe-vera-hair-conditioner"],
    note: "For someone who wants the old-style oil treatment, and something modern after it.",
    image: "/assets/p-kaachenna-hair-oil.jpg",
  },
  {
    id: "set-everyday",
    slug: "the-everyday-set",
    name: "The Everyday Set",
    kind: "set",
    price: 1050,
    contents: ["Aloevera Facewash", "Lip Balm", "Foot Balm"],
    items: ["aloevera-facewash-charcoal", "lip-balm", "foot-balm"],
    note: "Face, lips and feet. The set to buy for someone else — or to cross the free-delivery line.",
    image: "/assets/p-lip-balm.jpg",
  },
];

export const ALL_ITEMS = [...PRODUCTS, ...SETS];
export const findItem = (id) => ALL_ITEMS.find((i) => i.id === id);
export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const CATEGORIES = ["All", "Hair Care", "Skin Care", "Body Care", "Sets & Gifting"];

export const CLINIC = {
  name: "Ayushi Ayurveda Wellness",
  address: "Jas Buildings, Ground Floor, Chavadimukku, Sreekaryam, Thiruvananthapuram, Kerala 695017",
  phone: "96338 72322",
  phoneRaw: "+919633872322",
  whatsapp: "https://wa.me/919633872322",
  email: "ayushibydrshibina@gmail.com",
  hours: "Monday to Saturday, 10:00 AM to 7:00 PM. Closed Sunday.",
  consult: "Consultations 10:30 AM to 12:00 PM and 5:00 PM to 7:00 PM",
  rating: "4.9",
  reviewCount: 69,
  googleUrl: "https://www.google.com/maps/search/Ayushi+Ayurveda+Wellness+Sreekaryam",
};

export const PATCH_TEST_NOTE =
  "These are made from natural ingredients, and natural does not mean nobody reacts to it. Apply a small amount to the inside of your forearm and leave it for 24 hours before using it properly. If your skin reacts, stop using it. For external use only. If you are pregnant, have a skin condition, or are being treated for anything, ask your doctor first.";

export const ANNOUNCEMENTS = [
  "Free delivery across India on orders above ₹1,500",
  "Made in our own licensed facility in Thiruvananthapuram",
  "Formulated by Dr. Shibina Shemim, BAMS · 4.9 on Google across 69 reviews",
];
